interface IFilesTypes {
	[key: string]: {
		[x: string]: string[];
	};
}

const FILES_ACCEPTED_TYPES: IFilesTypes = {
	IMAGE: {
		'image/png': ['.png'],
		'image/jpeg': ['.jpeg'],
		'image/jpg': ['.jpg'],
	},
	PDF: {
		'application/pdf': ['.pdf'],
	},
	VIDEO: {
		'video/*': ['.mp4', '.webm', '.wmv', '.ogg', '.mov'],
	},
	AUDIO: {
		'audio/mpeg': ['.mp3'],
		'audio/wav': ['.wav'],
		'audio/ogg': ['.ogg'],
		'audio/aac': ['.aac'],
		'audio/flac': ['.flac'],
		'audio/x-m4a': ['.m4a'],
		'audio/webm': ['.weba'],
	},
	MICROSOFT_OFFICE: {
		'application/msword': ['.doc'],
		'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
		'application/vnd.ms-excel': ['.xls'],
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
		'application/vnd.ms-powerpoint': ['.ppt'],
		'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
		'application/vnd.ms-excel.sheet.macroEnabled.12': ['.xlsm'],
		'application/vnd.ms-excel.template.macroEnabled.12': ['.xltm'],
		'application/vnd.ms-powerpoint.presentation.macroEnabled.12': ['.pptm'],
		'application/vnd.openxmlformats-officedocument.presentationml.template': ['.potx'],
		'application/vnd.ms-powerpoint.template.macroEnabled.12': ['.potm'],
		'application/vnd.ms-powerpoint.slideshow.macroEnabled.12': ['.ppsm'],
		'application/vnd.openxmlformats-officedocument.presentationml.slideshow': ['.ppsx'],
		'application/vnd.ms-access': ['.mdb'],
		'application/vnd.openxmlformats-officedocument.wordprocessingml.template': ['.dotx'],
		'application/vnd.ms-word.document.macroEnabled.12': ['.docm'],
		'application/vnd.ms-word.template.macroEnabled.12': ['.dotm'],
		'application/vnd.ms-publisher': ['.pub'],
		'application/rtf': ['.rtf'],
		'application/vnd.ms-excel.sheet.binary.macroEnabled.12': ['.xlsb'],
		'application/vnd.openxmlformats-officedocument.spreadsheetml.template': ['.xltx'],
		'application/vnd.ms-excel.addin.macroEnabled.12': ['.xlam'],
		'application/vnd.ms-powerpoint.addin.macroEnabled.12': ['.ppam'],
		'application/vnd.ms-project': ['.mpp', '.mpt'],
		'application/vnd.visio': ['.vsd'],
		'application/vnd.ms-visio.drawing': ['.vsdx'],
		'application/vnd.ms-visio.template': ['.vstx'],
		'application/vnd.ms-visio.stencil': ['.vssx'],
		'application/vnd.ms-xpsdocument': ['.xps'],
		'application/x-msmoney': ['.mny'],
		'application/x-msworks-wp': ['.wps'],
		'application/vnd.ms-works': ['.wks'],
		'application/vnd.oasis.opendocument.text': ['.odt'],
		'application/vnd.oasis.opendocument.spreadsheet': ['.ods'],
		'application/vnd.oasis.opendocument.presentation': ['.odp'],
		'text/csv': ['.csv'],
		'text/plain': ['.txt'],
		'application/xml': ['.xml'],
	},
};

export type AcceptedTypesKeys = keyof typeof FILES_ACCEPTED_TYPES;

export default FILES_ACCEPTED_TYPES;

export enum FileUploadErrorsCodes {
	LargeFile = 'file-too-large',
	InvalidType = 'file-invalid-type',
}
